export class FrontendError extends Error {
  public readonly name = 'FrontendError'
}
